import { Box, Button, Typography, Grid, TextField, MenuItem } from '@mui/material'
import React, { ChangeEvent, FormEvent, useRef, useState } from 'react'
import { UploadUrl, ContactUsSubmitUrl } from '../../../common/url'
import axios from 'axios'
import { message } from 'antd'
import { setTimeout } from 'timers'
import ReCAPTCHA from 'react-google-recaptcha'
import { useTranslation } from 'react-i18next'

export const SMHelpAndAdvice: React.FC = () => {

  const { t } = useTranslation()

  const [forms, setForms] = useState({
    otherSalutation: '',
    name: '',
    email: '',
    phone: '',
    loanAgreementNumber: '',
    message: '',
  })

  const [salutation, setSalutation] = useState(t('t410'))

  const [subject, setSubject] = useState(t('t415'))

  const [file, setFile] = useState(null)

  const [fileName, setFileName] = useState(null)

  const salutationList = [t('t410'), t('t411'), t('t412'), t('t413')]

  const [otherSubject, setOtherSubject] = useState(null)

  const [captchaValue, setCaptchaValue] = useState('')

  const list1 = [
    {
      id: 'salutation',
      title: t('t401'),
      placeholder: t('t405'),
      select: true,
    },
    {
      id: 'name',
      title: t('t402'),
      placeholder: t('t406'),
      select: false,
      value: forms.name,
    },
    {
      id: 'email',
      title: t('t403'),
      placeholder: t('t407'),
      select: false,
      value: forms.email,
    },
    {
      id: 'phone',
      title: t('t404'),
      placeholder: t('t408'),
      select: false,
      value: forms.phone,
    },
  ]

  const list2 = [
    {
      id: 'salutation',
      title: t('t401'),
      placeholder: t('t405'),
      select: true,
    },
    {
      id: 'otherSalutation',
      title: t('t409'),
      placeholder: t('t409'),
      select: false,
      value: forms.otherSalutation,
    },
    {
      id: 'name',
      title: t('t402'),
      placeholder: t('t406'),
      select: false,
      value: forms.name,
    },
    {
      id: 'email',
      title: t('t403'),
      placeholder: t('t407'),
      select: false,
      value: forms.email,
    },
    {
      id: 'phone',
      title: t('t404'),
      placeholder: t('t408'),
      select: false,
      value: forms.phone,
    },
  ]

  const [data, setData] = useState(list1)

  const recaptchaRef = useRef()

  const salutationSelectItem = () => salutationList.map((item, index) => salutationMenuItem(index))

  const salutationMenuItem = (index: number) => {
    return (
      <MenuItem key={index} value={salutationList[index]} onClick={() => updateSalutation(index, salutationList[index])}>
        {salutationList[index]}
      </MenuItem>
    )
  }

  const updateSalutation = (index: number, text: string) => {
    setSalutation(text)
    if (index === salutationList.length - 1) {
      setData(list2)
    } else {
      setData(list1)
    }
  }

  const subjectList = [
    t('t415'),
    t('t416'),
    t('t417'),
    t('t418'),
    t('t419'),
    t('t420'),
    t('t421'),
  ]

  const subjectSelectItem = () => subjectList.map((item, index) => subjectMenuItem(index))

  const subjectMenuItem = (index: number) => {
    return (
      <MenuItem key={index} value={subjectList[index]} onClick={() => updateSubject(subjectList[index])}>
        {subjectList[index]}
      </MenuItem>
    )
  }

  const updateSubject = (text: string) => {
    setSubject(text)
  }

  const renderInputItem = (select: boolean, index: number, title: string, placeholder: string, id: string, value: string) => {
    return (
      <Grid item key={index.toString() + id} xs={6}>
        <Box
          sx={{
            width: '100%',
          }}
        >
          <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingBottom={'12px'}>
            {title}{' '}
            <span
              style={{
                color: '#FF4D49',
                fontSize: '16',
                fontWeight: '500',
              }}
            >
              *
            </span>
          </Typography>
          {select === true ? (
            <TextField
              select
              fullWidth
              variant="outlined"
              value={salutation}
              InputProps={{
                style: {
                  height: '53px',
                },
              }}
            >
              {salutationSelectItem()}
            </TextField>
          ) : (
            <TextField
              fullWidth
              placeholder={placeholder}
              variant="outlined"
              id={id}
              defaultValue={value}
              className={id}
              onChange={handleInputChange}
              InputProps={{
                style: {
                  height: '53px',
                },
              }}
            />
          )}
        </Box>
      </Grid>
    )
  }

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target

    setForms((prevForms) => ({
      ...prevForms,
      [id]: value,
    }))
  }

  const handleOtherSubjectChange = (e: ChangeEvent<HTMLInputElement>) => {
    setOtherSubject(e.target.value)
  }

  const handleFileChange = (e) => {
    const targetFile = e.target.files[0]
    setFileName(targetFile.name)
    setFile(targetFile)
  }

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()

    var currentCaptchaValue = recaptchaRef.current.getValue()
    // console.log('输入的value:', captchaValue)
    // console.log('当前value:', currentCaptchaValue)
    if (captchaValue === currentCaptchaValue && currentCaptchaValue !== '' && currentCaptchaValue !== null) {
        // console.log('验证通过')
    } else {
        // console.log('不通过')
        message.destroy()
        message.open({
          type: 'error',
          content: t('t428'),
          style: {
            marginTop: '40vh',
          },
        })
        return
    }

    if (salutation === t('t413') && (forms.otherSalutation === null || forms.otherSalutation === '')) {
      message.destroy()
      message.open({
        type: 'error',
        content: t('t429'),
        style: {
          marginTop: '40vh',
        },
      })
      return
    }

    if (forms.name === null || forms.name === '') {
      message.destroy()
      message.open({
        type: 'error',
        content: t('t430'),
        style: {
          marginTop: '40vh',
        },
      })
      return
    }

    if (forms.email === null || forms.email === '') {
      message.destroy()
      message.open({
        type: 'error',
        content: t('t431'),
        style: {
          marginTop: '40vh',
        },
      })
      return
    }

    if (forms.phone === null || forms.phone === '') {
      message.destroy()
      message.open({
        type: 'error',
        content: t('t432'),
        style: {
          marginTop: '40vh',
        },
      })
      return
    }

    if (subject === t('t421') && (otherSubject === null || otherSubject === '')) {
      message.destroy()
      message.open({
        type: 'error',
        content: t('t433'),
        style: {
          marginTop: '40vh',
        },
      })
      return
    }

    if (forms.message === null || forms.message === '') {
      message.destroy()
      message.open({
        type: 'error',
        content: t('t434'),
        style: {
          marginTop: '40vh',
        },
      })
      return
    }

    message.destroy()
    message.open({
      type: 'loading',
      content: t('t435'),
      duration: 0,
      style: {
        marginTop: '40vh',
      },
    })
    if (fileName === null || fileName === '') {
      submitApi('', '')
    } else {
      uploadFileApi()
    }
  }

  const uploadFileApi = async () => {
    try {
      const formData = new FormData()
      formData.append('files', file)
      const response = await axios.post(UploadUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      if (response.status === 200) {
        if (response.data !== null && response.data.length > 0) {
          const fileName = response.data[0]['name']
          const fileId = response.data[0]['id'].toString()
          submitApi(fileName, fileId)
        } else {
          message.destroy()
          message.open({
            type: 'error',
            content: t('t436'),
            style: {
              marginTop: '40vh',
            },
          })
        }
      } else {
        message.destroy()
        message.open({
          type: 'error',
          content: t('t436'),
          style: {
            marginTop: '40vh',
          },
        })
      }
    } catch (error) {
      message.destroy()
      message.open({
        type: 'error',
        content: t('t436'),
        style: {
          marginTop: '40vh',
        },
      })
    }
  }

  const submitApi = async (fileName: string, fileId: string) => {
    var params = {
      data: {
        salutation: salutation,
        otherSalutation: forms.otherSalutation,
        name: forms.name,
        email: forms.email,
        contactNumber: forms.phone,
        subject: subject,
        otherSubject: otherSubject,
        enquiry: forms.message,
        agreementNo: forms.loanAgreementNumber,
        fileName: fileName,
        fileId: fileId,
      },
    }
    try {
      const response = await axios.post(ContactUsSubmitUrl, params)
      if (response.status === 200) {
        message.destroy()
        message.open({
          type: 'success',
          content: t('t437'),
          style: {
            marginTop: '40vh',
          },
        })
        setTimeout(() => {
          window.location.reload()
        }, 1500)
      }
    } catch (error) {
      message.destroy()
      message.open({
        type: 'error',
        content: t('t436'),
        style: {
          marginTop: '40vh',
        },
      })
    }
  }

  /// 验证码
  const reCAPTCHAChange = (value) => {
    console.log('aptcha value:', value)
    setCaptchaValue(value)
  }

  // ======================= VIEWS
  return (
    <form onSubmit={handleSubmit}>
      <Box
        sx={{
          width: '100%',
          backgroundColor: '#FFFFFF',
          paddingLeft: '72px',
          paddingRight: '72px',
          paddingTop: '60px',
          paddingBottom: '60px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            paddingLeft: '12px',
            paddingRight: '12px',
            paddingBottom: '40px',
          }}
        >
          <Typography fontWeight={700} fontSize={'32px'} color={'#141F39'} textAlign={'center'}>
            {t('t400')}
          </Typography>
        </Box>

        <Box
          sx={{
            width: '100%',
            paddingLeft: '50px',
            paddingRight: '50px',
            paddingTop: '50px',
            paddingBottom: '50px',
            borderRadius: '10px',
            alignItems: 'center',
            boxShadow: '0px 10px 80px 3px #0000001A',
          }}
        >
          {/* Salutation * */}
          <Box>
            <Grid container columnSpacing={3} rowSpacing={2}>
              {data.map((item, index) => renderInputItem(data[index]['select'], index, data[index]['title'], data[index]['placeholder'], data[index]['id'], data[index]['value']))}
            </Grid>
          </Box>

          {/* Subject */}
          <Box
            sx={{
              width: '100%',
              paddingTop: '18px',
            }}
          >
            <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingBottom={'12px'}>
              {t('t414')}{' '}
              <span
                style={{
                  color: '#FF4D49',
                  fontSize: '16',
                  fontWeight: '500',
                }}
              >
                *
              </span>
            </Typography>
            <TextField
              select
              fullWidth
              variant="outlined"
              value={subject}
              InputProps={{
                style: {
                  height: '53px',
                },
              }}
            >
              {subjectSelectItem()}
            </TextField>
          </Box>

          {/* Other Subject */}
          {subject === t('t421') ? (
            <Box
              sx={{
                width: '100%',
                paddingTop: '18px',
              }}
            >
              <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingBottom={'12px'}>
                {t('t422')}{' '}
                <span
                  style={{
                    color: '#FF4D49',
                    fontSize: '16',
                    fontWeight: '500',
                  }}
                >
                  *
                </span>
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder={t('t422')}
                value={otherSubject}
                onChange={handleOtherSubjectChange}
                InputProps={{
                  style: {
                    height: '53px',
                  },
                }}
              >
                {subjectSelectItem()}
              </TextField>
            </Box>
          ) : (
            <></>
          )}

          {/* Loan Agreement Number And Upload File */}
          <Box
            sx={{
              width: '100%',
              paddingTop: '18px',
            }}
          >
            <Grid container columnSpacing={3} rowSpacing={5}>
              <Grid item key={'AgreementNumber'} xs={6}>
                <Box
                  sx={{
                    width: '100%',
                  }}
                >
                  <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingBottom={'12px'}>
                    {t('t423')}
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder={'XXXX XXXX XXXX'}
                    variant="outlined"
                    id={'loanAgreementNumber'}
                    onChange={handleInputChange}
                    InputProps={{
                      style: {
                        height: '53px',
                      },
                    }}
                  />
                </Box>
              </Grid>

              <Grid item key={'UploadFile'} xs={6}>
                <Box
                  sx={{
                    width: '100%',
                  }}
                >
                  <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingBottom={'12px'}>
                    {t('t424')}
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder={''}
                    variant="outlined"
                    id={'UploadFile'}
                    value={fileName === null ? '' : fileName}
                    disabled
                    InputProps={{
                      style: {
                        height: '53px',
                        paddingRight: '0px',
                      },
                      endAdornment: (
                        <Box
                          sx={{
                            width: '130px',
                            height: '100%',
                            backgroundColor: '#E4E4E4',
                            borderTopRightRadius: '15px',
                            borderBottomRightRadius: '15px',
                            alignContent: 'center',
                            cursor: 'pointer',
                          }}
                        >
                          <input
                            accept="image/*"
                            id="contained-button-file"
                            multiple={false}
                            type="file"
                            onChange={handleFileChange}
                            style={{
                              display: 'none',
                            }}
                          />
                          <label htmlFor="contained-button-file">
                            <Button
                              fullWidth
                              component="span"
                              sx={{
                                width: '130px',
                                height: '100%',
                                backgroundColor: '#E4E4E4',
                                bgcolor: '#E4E4E4',
                                color: '#141F39',
                                borderTopLeftRadius: '0px',
                                borderBottomLeftRadius: '0px',
                                textTransform: 'none',
                              }}
                            >
                              {t('t425')}
                            </Button>
                          </label>
                        </Box>
                      ),
                    }}
                  />
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      paddingTop: '12px',
                    }}
                  >
                    <Box
                      sx={{
                        flex: '1',
                        paddingRight: '16px',
                      }}
                    >
                      <Typography fontSize={14} fontWeight={400} color={'#BDBDBD'}>
                        Choose file to upload - PDF / PNG / JPEG
                      </Typography>
                    </Box>

                    <Typography fontSize={14} fontWeight={400} color={'#BDBDBD'}>
                      Max upload size: 5MB
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* Your Message * */}
          <Box
            sx={{
              width: '100%',
              paddingTop: '18px',
            }}
          >
            <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingBottom={'12px'}>
              {t('t426')}{' '}
              <span
                style={{
                  color: '#FF4D49',
                  fontSize: '16',
                  fontWeight: '500',
                }}
              >
                *
              </span>
            </Typography>
            <TextField
              fullWidth
              placeholder={''}
              multiline
              variant="outlined"
              id={'message'}
              onChange={handleInputChange}
              InputProps={{
                style: {
                  minHeight: '128px',
                  alignItems: 'start',
                },
              }}
            />
          </Box>

          {/* Submit */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ mt: 6 }}>
              <ReCAPTCHA sitekey='6LfwNkErAAAAACw1DJ3B4VkXq6Nabby3rlsrpH-w' ref={recaptchaRef} onChange={reCAPTCHAChange}></ReCAPTCHA>
            </Box>

            <Button
              type="submit"
              sx={{
                borderRadius: '30px',
                mt: 6,
                bgcolor: '#FFC107',
                color: '#141F39',
                '&:hover': {
                  bgcolor: '#FFC107',
                },
                height: '60px',
                paddingLeft: '50px',
                paddingRight: '50px',
                textTransform: 'none',
              }}
            >
              {t('t427')}
            </Button>
          </Box>
        </Box>
      </Box>
    </form>
  )
}

// ======================= EXPORT
export default SMHelpAndAdvice
